import { API_URL, SUBSCRIPTION_KEY } from '../../config/environment';
import { acquireAccessToken } from 'auth/hooks/authProvider';

const apiUrl = API_URL.substr(-1) === '/' ? API_URL.slice(0, -1) : API_URL;

async function AuthorizedHeaders() {
  const headers = new Headers();
  const token = await acquireAccessToken();
  headers.append('Authorization', `Bearer ${token}`);
  headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
  headers.append('Content-Type', 'application/json');
  return headers;
}

export async function retrieveSignalRData() {
  const negotiateUrl = apiUrl + '/broadcast/negotiate';

  const request = new Request(negotiateUrl, {
    method: 'GET',
    headers: await AuthorizedHeaders(),
  });

  const response = await fetch(request);
  if (!response.ok) {
    let err;
    try {
      const errObject = await response.json();
      err = errObject.error;
    } catch {
      throw new Error(response.statusText);
    }
    throw err;
  }

  return await response.json();
}
